import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import InvitationsList from './InvitationsList';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import RelatedUserList from './related-users/RelatedUserList';
import styled from 'styled-components';

const StyledListWrapper = styled.div`
    margin-bottom: 30px;
`;

const InvitationsListContainer = (props) => {
    const {
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.users.title') } />

                <Actions>
                    <CreateButton label={ translate('actions.invite') } basePath={ `current-account/invitations` } />
                </Actions>
            </Header>

            <StyledListWrapper>
                <RelatedUserList resource='account-users' />
            </StyledListWrapper>

            <StyledListWrapper>
                <InvitationsList { ...props } />
            </StyledListWrapper>
        </div>
    );
};

InvitationsListContainer.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default translate(InvitationsListContainer);


// WEBPACK FOOTER //
// ./src/pages/invitations/list/InvitationsListContainer.js